import { Body1, tokens } from '@fluentui/react-components';
/*
 * Function to check if date is today.
 */
const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
const oneWeek = 7 * oneDay;
const oneMonth = 30 * oneDay;
const oneYear = 365 * oneDay;

export function isToday(date: Date) {
    return date.toDateString() == new Date().toDateString();
}
export function isYesterday(date: Date) {
    const today = new Date();
    const yesterday = today;
    yesterday.setDate(today.getDate() - 1);
    return date.toDateString() == yesterday.toDateString();
}
export function isLastWeek(date: Date) {
    const today = new Date();
    return date > new Date(today.getTime() - oneWeek) && date <= today;
}
export function isLastMonth(date: Date) {
    const today = new Date();
    return date > new Date(today.getTime() - oneMonth) && date <= today;
}
export function isLastYear(date: Date) {
    const today = new Date();
    return date > new Date(today.getTime() - oneYear) && date <= today;
}

/*
 * Function to render the date and/or time of a message.
 */
export function timestampToDateString(timestamp: number, alwaysShowTime = false) {
    const date = new Date(timestamp);
    const dateString = date.toLocaleDateString([], {
        month: 'numeric',
        day: 'numeric',
    });
    const timeString = date.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
    });

    return date.toDateString() !== new Date().toDateString()
        ? alwaysShowTime
            ? dateString + ' ' + timeString // if the date is not today and we are always showing the time, show the date and time
            : dateString // if the date is not today and we are not always showing the time, only show the date
        : timeString; // if the date is today, only show the time
}

/*
 * Function to create a command link
 */
export function createCommandLink(command: string) {
    const escapedCommand = encodeURIComponent(command);
    const createCommandLink = `<span style="text-decoration: underline; cursor: pointer" data-command="${escapedCommand}" onclick="(function(){ let chatInput = document.getElementById('chat-input'); chatInput.value = decodeURIComponent('${escapedCommand}'); chatInput.focus(); return false; })();return false;">${command}</span>`;
    return createCommandLink;
}

/*
 * Function to format chat text content to remove any html tags from it.
 */
export function formatChatTextContent(messageContent: string) {
    const contentAsString = messageContent
        .trim()
        .replace(/^sk:\/\/.*$/gm, (match: string) => createCommandLink(match))
        .replace(/^!sk:.*$/gm, (match: string) => createCommandLink(match));
    return contentAsString;
}

/*
 * Formats text containing `\n` or `\r` into paragraphs.
 */
export function formatParagraphTextContent(messageContent = '') {
    messageContent = messageContent.replaceAll('\r\n', '\n\r');

    return (
        <Body1>
            {messageContent.split('\n').map((paragraph, idx) => (
                <p
                    key={`paragraph-${idx}`}
                    style={
                        paragraph.includes('\r')
                            ? {
                                  display: 'flex',
                                  marginLeft: tokens.spacingHorizontalL,
                              }
                            : {
                                  overflowWrap: 'anywhere',
                              }
                    }
                >
                    {paragraph}
                </p>
            ))}
        </Body1>
    );
}

/**
 * Gets message of error
 */
export function getErrorDetails(error: unknown) {
    return error instanceof Error ? error.message : String(error);
}

/**
 * [Func]
 * @param dateString
 * @returns Date를 받아 yyyy-mm-dd 형태로 반환
 */
export const formatDate = (dateString?: Date): string => {
    if (!dateString) {
        return 'N/A';
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }

    const yyyymmdd = date.toISOString().split('T')[0];
    return yyyymmdd;
};
